export default __webpack_public_path__ + "static/media/WFHPM.bfdb8579.svg";